module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// E:/topNews_work/topnews-share-sa/node_modules/readable-stream/transform.js
// module id = 95
// module chunks = 0